import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { LoginWrapper } from "../styled";
import { useNavigate, useSearchParams } from "react-router-dom";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { AuthImage, AuthImageAr } from "../../../components/styled/AllImages";
import AuthWelcome from "../../../components/auth/AuthWelcomeCol";
import ForgetPasswordModal from "../../../components/auth/Modal/ForgetPasswordModal";
import ForgetEmailSentModal from "../../../components/auth/Modal/ForgetEmailSentModal";
import { CustomCheckbox } from "../../../components/styled/FormElements";
import { toast } from "react-toastify";
import AuthApi from "../../../services/api/authApi";
import { AuthContext } from "../../../context/authContext";
import { useUser } from "../../../context/userContext";
import { normalizeLoginIdentifier } from "../../../utils/normalizeLoginIdentifier";
import { safeInternalPath } from "../../../utils";

const Login = () => {
  const { t, i18n } = useTranslation();
  const { fetchUserInfo } = useUser();
  const { login, tempLogin } = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = safeInternalPath(searchParams.get("next"));
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isReqLoading, setIsReqLoading] = useState(false);
  const [emailSentModalShow, setEmailSentModalShow] = useState(false);
  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const [isVisible, setIsVisible] = useState(window.innerWidth >= 992);

  const handleBtnClick = () => {
    setShowModal(false);
    setEmailSentModalShow(true);
  };
  const onSubmit = async (credentials) => {
    try {
      setLoading(true);
      const payload = {
        ...credentials,
        email_or_phone: normalizeLoginIdentifier(credentials.email_or_phone),
      };
      const response = await AuthApi.login(payload);
      if (response.code === 200) {
        if (response?.data?.access_token) {
          if (keepSignedIn) {
            login(response?.data?.access_token);
          } else {
            tempLogin(response?.data?.access_token);
          }
          await fetchUserInfo();
          toast.success(t("login_success"));
          if (Number(response?.data?.data?.four_step_completed) === 1) {
            navigate(nextPath || "/my-profile");
          } else {
            navigate("/registration");
          }
        }
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
      if (response.code === 400) {
        toast.error(response.error);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const handelResize = () => {
      setIsVisible(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handelResize);
    return () => {
      window.removeEventListener("resize", handelResize);
    };
  }, []);

  return (
    <LoginWrapper>
      <AuthHeader />
      <Box className="container-fluid containerAuth">
        <Row>
          <Col lg={6} md={12} sm={12} className="px-4 overflow-y-auto authCol">
            <Box className="logSignInner">
              <Box>
                <Box className="mb-4">
                  <HeadingStyled size="24px">
                    {t("wellcome_back")}
                  </HeadingStyled>
                  <TextStyled>{t("please_enter_email_password")}</TextStyled>
                </Box>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Box>
                    <Box>
                      <ValidatedInput
                        name="email_or_phone"
                        label={"EmailPhone"}
                        type="input"
                        fieldType="text"
                        placeholder={"EmailPhone"}
                        register={register}
                        className={"mb-4 combined flex-wrap p-0"}
                        errors={errors}
                        validationRules={{
                          required: true,
                          // pattern: {
                          //   value: emailRegex,
                          //   message: "invalidEmail",
                          // },
                        }}
                      />
                      <ValidatedInput
                        name="password"
                        label={"password"}
                        type="input"
                        fieldType="password"
                        placeholder={"passwordPlaceholder"}
                        errors={errors}
                        register={register}
                        validationRules={{
                          required: true,
                          inline: true,
                          minLength: {
                            value: 8,
                            message: "lengthGreaterThen",
                          },
                        }}
                        className={"mb-4 combined flex-wrap p-0"}
                      />
                      <CustomCheckbox
                        name="keepsign"
                        label={t("Keepmesignedin")}
                        checked={keepSignedIn}
                        labelClass=""
                        onChange={(e) => setKeepSignedIn(!keepSignedIn)}
                      />
                      <FormButtonStyled
                        type="submit"
                        label={t("sign_in")}
                        className="w-100"
                        clName="w-100 my-4"
                        isLoading={loading}
                      />
                    </Box>
                    <Box className="d-flex justify-content-center justify-content-sm-end mb-3">
                      <Box>
                        <TextStyled
                          className="cursor-pointer"
                          color="var(--themeColorSecondary)"
                          onClick={() => setShowModal(true)}
                        >
                          {t("forgot_password")}
                        </TextStyled>
                      </Box>
                    </Box>
                  </Box>
                </Form>
              </Box>
              <Box className="d-flex justify-content-center justify-content-center mb-4">
                <Box className="d-block w-100 text-center">
                  <TextStyled
                    className="d-inline-block w-auto"
                    color="var(--darkGrey)"
                  >
                    {t("Donthaveaccount")}&nbsp;
                  </TextStyled>
                  <TextStyled
                    className="cursor-pointer d-inline-block w-auto"
                    color="var(--themeColorSecondary)"
                    onClick={() => navigate("/signup")}
                  >
                    {t("sign_up")}
                  </TextStyled>
                </Box>
              </Box>
            </Box>
          </Col>
          {isVisible && <AuthWelcome logSignImg={i18n.language === "en" ? AuthImage : AuthImageAr} />}
        </Row>
      </Box>
      <ForgetPasswordModal
        show={showModal}
        onHide={() => setShowModal(false)}
        setEmailSentModalShow={setEmailSentModalShow}
        isLoading={isReqLoading}
      />
      <ForgetEmailSentModal
        show={emailSentModalShow}
        onHide={() => setEmailSentModalShow(false)}
      />
    </LoginWrapper>
  );
};

export default Login;
